import axios from 'axios';
import { API_URL, config } from '../../../config/config';

export const getAllModules = async () => {
	const res = await axios.post(`${API_URL}/module-access/get-all-modules`, {}, config);
	return res.data;
};
